<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="160px">
      <el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件">
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.identificationImg"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '身份证人像面照片',
                  prefix: 'identification',
                  form: form,
                  suffix: 'Img'
                }"
                :required="!!requireData.identificationImg"
                @handleImgSuccess="ficationImgSuccess"
              />
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.identificationBackImg"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '身份证国徽面照片',
                  prefix: 'identificationBack',
                  form: form,
                  suffix: 'Img'
                }"
                :required="!!requireData.identificationBackImg"
                @handleImgSuccess="ficationImgBackSuccess"
              />
              <el-checkbox
                v-if="checkQuire"
                v-model="requireData.identificationInhandImg"
                :true-label="1"
                :false-label="0"
              />
              <!-- <ImgUpload
                :upload-config="{
                  lebal: '手持身份证合照',
                  prefix: 'identificationInhand',
                  form: form,
                  suffix: 'Img',
                }"
                :required="!!requireData.identificationInhandImg"
              /> -->
              <el-checkbox
                v-if="checkQuire && parentData.isCompany"
                v-model="requireData.businessLicenseImg"
                :true-label="1"
                :false-label="0"
              />
              <ImgUpload
                v-if="parentData.isCompany"
                :upload-config="{
                  lebal: '企业营业执照',
                  prefix: 'businessLicense',
                  form: form,
                  suffix: 'Img'
                }"
                :required="!!requireData.businessLicenseImg"
                @handleImgSuccess="businessImgSuccess"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-col v-if="parentData.isCompany" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.userName"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('userName')"
          />
          <el-form-item label="联系人" prop="userName">
            <el-input
              v-model.trim="form.userName"
              placeholder="请输入联系人"
              clearable
              @change="
                value => {
                  form.userName = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col v-if="!parentData.isCompany" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.userName"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('userName')"
          />
          <el-form-item label="托运人姓名" prop="userName">
            <el-input
              v-model="form.userName"
              placeholder="请输入托运人姓名"
              clearable
              @change="
                value => {
                  form.userName = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              autocomplete="off"
              placeholder="请输入联系方式"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.upass"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('upass')"
          />
          <el-form-item label="密码" prop="upass">
            <el-input
              v-model="form.upass"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="parentData.isCompany" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.companyName"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('companyName')"
          />
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              v-model="form.companyName"
              placeholder="请输入公司名称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="parentData.isCompany" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.businessLicenseImgNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('businessLicenseImgNumber')"
          />
          <el-form-item
            label="统一社会信用代码"
            prop="businessLicenseImgNumber"
          >
            <el-input
              v-model="form.businessLicenseImgNumber"
              placeholder="请输入统一社会信用代码"
              clearable
              @change="
                value => {
                  form.businessLicenseImgNumber = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col v-if="parentData.isCompany" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.legalName"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('legalName')"
          />
          <el-form-item label="法人代表名称" prop="legalName">
            <el-input
              v-model="form.legalName"
              placeholder="请输入法人代表名称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.identificationNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('identificationNumber')"
          />
          <el-form-item label="身份证号" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入身份证号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="checkQuire ? 12 : 9">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.idCardDueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('idCardDueDate')"
          />
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="!checkQuire" :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col v-if="parentData.isCompany && hasTaxOpen" :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.myTaxOrgan"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('myTaxOrgan')"
          />
          <el-form-item
            label="所属主管税务机关"
            prop="myTaxOrgan"
            label-width="160px"
          >
            <el-input
              v-model="form.myTaxOrgan"
              placeholder="请输入所属主管税务机关"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.prefix"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('prefix')"
          />
          <el-form-item label="简称码" prop="prefix">
            <el-input
              v-model="form.prefix"
              placeholder="请输入2-4位纯字母的托运人简称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.taxPoint"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('taxPoint')"
          />
          <el-form-item label="服务费率(%)" prop="taxPoint">
            <el-input
              v-model="form.taxPoint"
              type="number"
              placeholder="请输入服务费比例"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.areaList"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('areaList')"
          />
          <el-form-item label="企业通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children',
              }"
              clearable
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.address"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('address')"
          />
          <el-form-item label="详细地址" prop="address">
            <el-input
              v-model="form.address"
              placeholder="请输入详细地址"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!parentData.isCompany && hasTaxOpen">
        <el-col :span="24">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.myTaxOrgan"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('myTaxOrgan')"
          />
          <el-form-item
            label="所属主管税务机关"
            prop="myTaxOrgan"
            label-width="160px"
          >
            <el-input
              v-model="form.myTaxOrgan"
              placeholder="请输入所属主管税务机关"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!checkQuire" style="line-height: 36px">
        <el-col :span="22" :offset="1">
          <div style="padding-bottom: 22px">
            <el-checkbox
              v-model="form.isMonthlyClient"
              label="是否为月结客户"
              :checked="!!form.isMonthlyClient"
              :false-label="0"
              :true-label="1"
              :disabled="!!form.isEnsure"
              @change="value => (form.isEnsure = 0)"
            />
            <!-- <el-checkbox
              v-if="ctmsShow"
              v-model="form.isIndependentCheckout"
              label="是否独立核算"
              :checked="!!form.isIndependentCheckout"
              :false-label="0"
              :true-label="1"
            /> -->
            <el-checkbox
              v-if="ctmsShow"
              v-model="form.isLoadConfirm"
              label="是否装货确认"
              :checked="!!form.isLoadConfirm"
              :false-label="0"
              :true-label="1"
            />
            <el-checkbox
              v-if="ctmsShow"
              v-model="form.isUnloadConfirm"
              label="是否确认签收"
              :checked="!!form.isUnloadConfirm"
              :false-label="0"
              :true-label="1"
            />
            <el-checkbox
              v-if="ctmsShow"
              v-model="form.isReleaseCheck"
              label="货源是否需要平台审核"
              :checked="!!form.isReleaseCheck"
              :false-label="0"
              :true-label="1"
            />
            <el-checkbox
              v-if="ctmsShow"
              v-model="form.isEnsure"
              label="是否需要发货保证金"
              :checked="!!form.isEnsure"
              :false-label="0"
              :true-label="1"
              :disabled="!!form.isMonthlyClient"
              @change="value => (form.isMonthlyClient = 0)"
            />
          </div>
        </el-col>
        <!-- <el-col :span="4" v-if="form.isEnsure">
          <el-form-item prop="ensureFee">
            <el-input v-model="form.ensureFee" placeholder="请输入保证金" />
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row v-if="form.isEnsure">
        <el-col :span="5">
          <el-form-item prop="ensureFee" label="发货保证金">
            <el-input
              v-model="form.ensureFee"
              placeholder="请输入保证金"
              :disabled="parentData.hideCheckbox"
            >
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button v-if="!checkQuire" type="primary" plain @click="funcSubmit()">
      提交
    </el-button>
    <el-button
      v-if="checkQuire && isAdmin"
      type="primary"
      plain
      @click="funcSaveSet()"
    >
      保存必填设置
    </el-button>
  </div>
</template>
<script>
import { addShipperInfo, getOcr } from "@/api/shipment";
import ImgUpload from "@/components/ImgUpload";
import {
  validatePhone,
  validateIDNumber,
  validatePrefix
} from "@/utils/validate.js";
import { findByFieldFrom, updateFieldRequired } from "@/api/required";
import { getRole } from "@/utils/getRole";
import { realDay } from "@/utils/validate";
import request from "@/utils/request";
import {
  mayDecimal,
  isBetweenHundred,
  checkPassword
} from "@/utils/validate4Form.js";
export default {
  name: "ShipmentAdd",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          isCompany: false
        };
      }
    }
  },
  data() {
    return {
      branchCode: "",
      ctmsShow: true, //显示独立核算,显示确认装货,显示卸货确认,显示平台审核,显示发货保证金
      hasTaxOpen: false, //是否开启税务
      // 必填功能
      checkQuire: false,
      isAdmin: false,
      requireData: {},
      emptyForm: {},
      form: {
        staffType: 0, // 默认类型
        userName: "",
        legalName: "",
        upass: "",
        phone: "",
        companyName: "",
        businessLicenseImgNumber: "", // 信用代码
        prefix: "",
        taxPoint: 0,
        areaList: [],
        address: "",
        identificationImg: "",
        identificationBackImg: "",
        identificationInhandImg: "",
        identificationNumber: "",
        businessLicenseImg: "",
        isIndependentCheckout: 0,
        isLoadConfirm: 1,
        isUnloadConfirm: 1,
        isReleaseCheck: 1,
        isMonthlyClient: 0,
        isEnsure: 0,
        ensureFee: "",
        needVerifyCompany: "",
        myTaxOrgan: "",
        hasDueDate: false
      },
      rules: {
        userName: [
          { required: false, message: "请输入托运人姓名", trigger: "blur" },
          { max: 64, message: "长度不能超过64个字符", trigger: "blur" }
        ],
        legalName: [
          { required: false, message: "请输入法人代表名称", trigger: "blur" },
          { max: 64, message: "长度不能超过64个字符", trigger: "blur" }
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            },
            trigger: "blur"
          }
        ],
        identificationNumber: [
          {
            required: false,
            message: "请输入身份证号",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              validateIDNumber(value)
                ? callback()
                : callback(new Error("请输入正确的身份证号"));
            },
            trigger: "blur"
          }
        ],
        idCardDueDate: [
          {
            required: false,
            message: "请选择身份证有效期",
            trigger: "change"
          }
        ],
        upass: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        companyName: [
          { required: false, message: "请输入公司名称", trigger: "blur" },
          { max: 100, message: "长度不能超过100个字符", trigger: "blur" }
        ],
        businessLicenseImgNumber: [
          {
            required: false,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
          { max: 100, message: "最大长度为100个字符", trigger: "blur" }
        ],
        prefix: [
          { required: false, message: "请输入托运人简称", trigger: "blur" },
          {
            validator(rule, value, callback) {
              validatePrefix(value)
                ? callback()
                : callback(new Error("请输入2-4位纯字母的托运人简称"));
            },
            trigger: "blur"
          }
        ],
        taxPoint: [
          { required: false, message: "请输入服务费", trigger: "blur" },
          { validator: isBetweenHundred, trigger: "blur" }
        ],
        address: [
          { required: false, message: "请输入详细地址", trigger: "blur" },
          {
            min: 1,
            max: 256,
            message: "长度在 1 到 256个字符",
            trigger: "blur"
          }
        ],
        areaList: [
          { required: false, message: "请选择企业通信地址", trigger: "change" }
        ],
        ensureFee: [
          { required: false, message: "请输入保证金", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ],
        myTaxOrgan: [
          {
            required: false,
            message: "请输入所属主管税务机关",
            trigger: "blur"
          },
          { max: 255, message: "最大长度为255个字符", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    // 监听路由刷新
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      if (["AddShipmentCompanyForm", "AddShipmentForm"].includes(cachedViews)) {
        this.$refs.form.resetFields();
      }
    }
  },
  activated() {
    if (JSON.stringify(this.requireData) != "{}") {
      this.findByFieldFrom(); //每次进入重新获取必填数据
    }
  },
  created() {
    this.branchCode = this.$store.state.user.party.branchCode;
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.checkQuire = !!this.$route.query.checkQuire;
    // let type = this.$route.query.type
    // if(type==='add'){
    //   this.form = JSON.parse(JSON.stringify(this.emptyForm))
    //   this.$forceUpdate();
    // }
    this.findByFieldFrom();
    this.ctmsShow = !getRole();
    this.form.staffType = this.parentData.isCompany ? 1 : 0;
    /*if (this.parentData.isCompany) {
      request({
        url: `/ntocc-basic-api/shipment/companyVerify`,
        method: "get",
      }).then((response) => {
        this.form.needVerifyCompany = response.data;

      });
    }*/
    request({
      url: `/ntocc-basic-api/industry/isOpen`,
      method: "get"
    }).then(response => {
      this.hasTaxOpen = response.data ? true : false;
    });
  },
  methods: {
    // 查询必填项
    async findByFieldFrom() {
      let isCompany = this.$route.query.company
        ? "shipmentCompany"
        : "shipment";
      let response = await findByFieldFrom({
        fieldFrom: isCompany,
        branchCode: this.branchCode
      });
      this.requireData = response.data;
      for (let key in this.requireData) {
        if (this.rules[key])
          this.rules[key][0].required = !!this.requireData[key];
      }
    },
    // 保存必填设置
    async funcSaveSet() {
      const rLoading = this.openLoading();
      let isCompany = this.$route.query.company
        ? "shipmentCompany"
        : "shipment";
      let response = await updateFieldRequired({
        message: this.requireData,
        fieldFrom: isCompany,
        branchCode: this.branchCode
      });
      rLoading.close();
      this.$message.success(response.msg);
      this.$router.go(-1);
      // this.checkQuire = false
    },
    // 设置必填
    setQuired(key) {
      this.rules[key][0].required = !!this.requireData[key];
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          this.form.ensureFee = this.form.isEnsure ? this.form.ensureFee : 0;
          this.form.staffType = this.parentData.isCompany ? 1 : 0;
          this.form.taxPoint = parseFloat(this.form.taxPoint);
          addShipperInfo(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.form = JSON.parse(JSON.stringify(this.emptyForm));
            this.$refs.form.resetFields();
            this.jumpToList();
          });
          /*if (this.form.needVerifyCompany && this.form.staffType === 1) {
            request({
              url: `/ntocc-basic-api/shipment/verifyCompany`,
              method: "get",
              params: this.form,
            }).then((response) => {
              const res = response.data;
              if (res.pass === 1) {
                this.form.verifyCompany = 1;
                this.form.ensureFee = this.form.isEnsure
                  ? this.form.ensureFee
                  : 0;
                this.form.staffType = this.parentData.isCompany ? 1 : 0;
                addShipperInfo(this.form).then((response) => {
                  rLoading.close();
                  this.$message({ message: response.msg, type: "success" });
                  this.jumpToList();
                });
              } else {
                this.form.verifyCompany = 0;
                this.$confirm(res.msg + "，是否继续保存?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    const rLoading = this.openLoading();
                    this.form.ensureFee = this.form.isEnsure
                      ? this.form.ensureFee
                      : 0;
                    this.form.staffType = this.parentData.isCompany ? 1 : 0;
                    addShipperInfo(this.form).then((response) => {
                      rLoading.close();
                      this.$message({ message: response.msg, type: "success" });
                      this.jumpToList();
                    });
                  })
                  .catch(() => {
                    return;
                  });
              }
            });
          } else {
            this.form.verifyCompany = 1; //如果设置不需要验证三要素则默认是验证通过状态
            this.form.ensureFee = this.form.isEnsure ? this.form.ensureFee : 0;
            this.form.staffType = this.parentData.isCompany ? 1 : 0;
            addShipperInfo(this.form).then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.jumpToList();
            });
          }*/
        }
        // else {
        //   this.$message.error("请输入有效值!");
        // }
      });
    },
    // 跳转
    jumpToList() {
      if (this.parentData.isCompany) {
        // 企业
        this.$router.push({
          path: "/basicInfo/shipment/shipmentCompanyManage",
          query: { needRefreshCompany: true }
        });
      } else {
        // 个人
        this.$router.push({
          path: "/basicInfo/shipment/shipmentManage",
          query: { needRefresh: true }
        });
      }
    },
    // 身份证正面识别
    async ficationImgSuccess(url) {
      if (url) {
        let res = await getOcr({
          image: url,
          ocrType: "ocrIdidentityCardFront"
        });
        let data = res.data;
        if (data.name) {
          if (this.parentData.isCompany) {
            this.form.legalName = data.name;
          } else {
            this.form.userName = data.name;
          }
        }
        data.identity ? (this.form.identificationNumber = data.identity) : null;
        this.form.staffType != "1" && data.address
          ? (this.form.address = data.address)
          : null;
        if (data.provinceCode && this.form.staffType != "1") {
          this.$set(this.form, "provinceCode", data.provinceCode);
          this.$set(this.form, "cityCode", data.cityCode);
          this.$set(this.form, "countyCode", data.countyCode);
          this.$set(this.form, "areaList", [
            data.provinceCode,
            data.cityCode,
            data.countyCode
          ]);
        }
      }
    },
    // 身份证反面识别
    async ficationImgBackSuccess(url) {
      if (url) {
        let res = await getOcr({
          image: url,
          ocrType: "ocrIdidentityCardFrontBack"
        });
        let data = res.data;
        if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
          this.$set(this.form, "hasDueDate", true);
          this.$set(this.form, "idCardDueDate", "9999-12-31");
        } else if (data.expiryDate) {
          let time = data.expiryDate.replace(/[^\d]/g, "");
          if (realDay(time)) {
            let expiryDate =
              time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
            this.$set(this.form, "idCardDueDate", expiryDate);
            this.$set(this.form, "hasDueDate", false);
          }
        }
        data.identity ? (this.form.identificationNumber = data.identity) : null;
        this.form.staffType != "1" && data.address
          ? (this.form.address = data.address)
          : null;
        if (data.provinceCode && this.form.staffType != "1") {
          this.$set(this.form, "provinceCode", data.provinceCode);
          this.$set(this.form, "cityCode", data.cityCode);
          this.$set(this.form, "countyCode", data.countyCode);
          this.$set(this.form, "areaList", [
            data.provinceCode,
            data.cityCode,
            data.countyCode
          ]);
        }
      }
    },
    // 社会信用识别
    async businessImgSuccess(url) {
      if (url) {
        let res = await getOcr({ image: url, ocrType: "ocrBusinessLicense" });
        let data = res.data;
        if (data.creditNum !== "无") {
          this.$set(this.form, "businessLicenseImgNumber", data.creditNum);
        }
        if (data.companyName && data.companyName != "无") {
          this.$set(this.form, "companyName", data.companyName);
        }
        if (data.legalPerson && data.legalPerson != "无") {
          this.$set(this.form, "legalName", data.legalPerson);
        }
        if (data.address) {
          this.$set(this.form, "address", data.address);
        }
        if (data.provinceCode) {
          this.$set(this.form, "provinceCode", data.provinceCode);
          this.$set(this.form, "cityCode", data.cityCode);
          this.$set(this.form, "countyCode", data.countyCode);
          this.$set(this.form, "areaList", [
            data.provinceCode,
            data.cityCode,
            data.countyCode
          ]);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form-item .el-date-editor.el-input {
  width: 100%;
}
</style>
